import { render, staticRenderFns } from "./StatementTextPanel.vue?vue&type=template&id=91490b6a&"
import script from "./StatementTextPanel.vue?vue&type=script&lang=js&"
export * from "./StatementTextPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports